// import { DatePipe } from '@angular/common';
// import { Pipe, PipeTransform } from '@angular/core';

// @Pipe({
//   name: 'localDate'
// })
// export class LocalDateTimeZonePipe implements PipeTransform {
//   private minuteTimeZone: any;
//   private readonly defaultFormat = "dd/MM/yyyy";
//   constructor(private datePipe: DatePipe) {
//     this.minuteTimeZone = (-new Date().getTimezoneOffset());
//   }
//   transform(value: any, format?: string | undefined, locale?: string | undefined): string | null {
//     let initDate = new Date(value);
//     initDate.setMinutes((initDate.getMinutes() + this.minuteTimeZone));
//     return this.datePipe.transform(initDate, (format ? format : this.defaultFormat), undefined, locale);
//   }
// }

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'localDateTimeZone'
})
export class LocalDateTimeZonePipe implements PipeTransform {
  transform(value: any, format?: string): any {
    const date = new Date(value);
    const offset = date.getTimezoneOffset();
    const localDate = new Date(date.getTime() - (offset * 60 * 1000));
    const localDateTime = localDate.toISOString().slice(0, 19).replace('T', ' ');

    if (format) {
      return this.formatLocalDateTime(localDateTime, format);
    } else {
      return localDateTime;
    }
  }

  private formatLocalDateTime(dateTime: string, format: string): string {
    const options = this.parseFormatString(format);
    return new Date(dateTime).toLocaleString(undefined, options);
  }

  private parseFormatString(format: string): Intl.DateTimeFormatOptions {
    const options: Intl.DateTimeFormatOptions = {};

    const dayIndex = format.indexOf('dd');
    if (dayIndex >= 0) {
      options.day = '2-digit';
    } else if (format.indexOf('d') >= 0) {
      options.day = 'numeric';
    }

    const monthIndex = format.indexOf('MM');
    if (monthIndex >= 0) {
      options.month = '2-digit';
    } else if (format.indexOf('M') >= 0) {
      options.month = 'numeric';
    } else if (format.indexOf('MMM') >= 0) {
      options.month = 'short';
    } else if (format.indexOf('MMMM') >= 0) {
      options.month = 'long';
    }

    const yearIndex = format.indexOf('yyyy');
    if (yearIndex >= 0) {
      options.year = 'numeric';
    } else if (format.indexOf('yy') >= 0) {
      options.year = '2-digit';
    }

    const hourIndex = format.indexOf('HH');
    if (hourIndex >= 0) {
      options.hour = '2-digit';
    } else if (format.indexOf('H') >= 0) {
      options.hour = 'numeric';
    } else if (format.indexOf('hh') >= 0) {
      options.hour = '2-digit';
      options.hour12 = true;
    } else if (format.indexOf('h') >= 0) {
      options.hour = 'numeric';
      options.hour12 = true;
    }

    const minuteIndex = format.indexOf('mm');
    if (minuteIndex >= 0) {
      options.minute = '2-digit';
    } else if (format.indexOf('m') >= 0) {
      options.minute = 'numeric';
    }

    const secondIndex = format.indexOf('ss');
    if (secondIndex >= 0) {
      options.second = '2-digit';
    } else if (format.indexOf('s') >= 0) {
      options.second = 'numeric';
    }

    return options;
  }
}
